import { FC, SVGProps } from "react";

export const PlayIcon: FC<SVGProps<SVGSVGElement>> = ({
  width = 20,
  height = 20,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M6 4.2v15.6a1 1 0 0 0 1.52.85l12.6-7.8a1 1 0 0 0 0-1.7L7.52 3.35A1 1 0 0 0 6 4.2Z" />
  </svg>
);
